import React from 'react';

import './home.css';
import ErrorSec from '../components/errorsec';

const Error = () => {
  return (<>
    
      <div className="home-page">
        <ErrorSec />

      </div>
      </>);
};

export default Error;